export default __webpack_public_path__ + "static/Roots-71a5deb368a2132a45b9c2df674c14b1.png";